import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@capacitor+preferences@7.0.4_@capacitor+core@7.6.5__@parcel+watcher@2.5.6_@_794e6fe582a4bee9a5b6e343880556a7/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@capacitor+preferences@7.0.4_@capacitor+core@7.6.5__@parcel+watcher@2.5.6_@_794e6fe582a4bee9a5b6e343880556a7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}